var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2515 6.77916H18.2619M7.30063 2.08594H17.73C20.61 2.08594 22.9447 4.42063 22.9447 7.30063V17.73C22.9447 20.61 20.61 22.9447 17.73 22.9447H7.30063C4.42063 22.9447 2.08594 20.61 2.08594 17.73V7.30063C2.08594 4.42063 4.42063 2.08594 7.30063 2.08594ZM16.6871 11.8583C16.8158 12.7262 16.6675 13.6127 16.2634 14.3916C15.8593 15.1704 15.2198 15.802 14.436 16.1966C13.6522 16.5911 12.764 16.7284 11.8977 16.589C11.0313 16.4496 10.231 16.0405 9.61057 15.4201C8.9901 14.7996 8.58108 13.9993 8.44167 13.133C8.30227 12.2666 8.43959 11.3784 8.83409 10.5946C9.22859 9.81083 9.86019 9.17139 10.6391 8.76725C11.4179 8.36311 12.3044 8.21486 13.1724 8.34357C14.0577 8.47486 14.8774 8.88742 15.5103 9.52032C16.1432 10.1532 16.5558 10.9729 16.6871 11.8583Z",
    stroke: "white",
    strokeWidth: 2.08588,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInsta);
export default __webpack_public_path__ + "static/media/social-insta.ecc3e6485dea4e50307ed631c8589942.svg";
export { ForwardRef as ReactComponent };